export class AuthRegister {
    constructor (public name:String, public email:String, public username:String, public password:String) {

    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/auth-register.ts